<template lang="pug">
.new-location
  shForm(title="Nueva Ubicación")
</template>

<script>
import shForm from '@/components/pages/location/Form'

export default {
  name: 'NewLocation',

  components: { shForm }
}
</script>

<style lang="stylus">
.new-location
  position relative
</style>



// WEBPACK FOOTER //
// src/components/pages/location/New.vue